"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollatorSensitivity = void 0;
// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator
exports.CollatorSensitivity = {
    ACCENT: 'accent',
    BASE: 'base',
    CASE: 'case',
    VARIANT: 'variant',
};
